<template>
  <div class="exdialog">
    <form-dialog :title="$t('log.export')" :dialogVisible="dialogVisible" :center="true" @closeDialog="handleClose" dWidth="550px" class="eldialog" top="20vh">
      <div class="content">
        <div class="picker">
          <span>{{$t('log.dateArr')}}：</span>
          <div class="pick" v-if="this.type!='terminal'">
            <el-date-picker v-model="startDate" align="right" type="date" :placeholder="$t('log.startDate')" value-format="yyyy-MM-dd" @change="startDateChange">
            </el-date-picker>
            <span>——</span>
            <el-date-picker v-model="endDate" align="right" type="date" :placeholder="$t('log.endDate')" value-format="yyyy-MM-dd" @change="endDateChange">
            </el-date-picker>
          </div>
          <div class="pick" v-else>
            <el-date-picker v-model="tStartDate" align="right" type="date" :placeholder="$t('log.startDate')" value-format="timestamp" @change="startDateChange">
            </el-date-picker>
            <span>——</span>
            <el-date-picker v-model="tEndDate" align="right" type="date" :placeholder="$t('log.endDate')" value-format="timestamp" @change="endDateChange">
            </el-date-picker>
          </div>
        </div>
        <div class="button_group">

          <el-button @click='close' round>{{$t('terminal.cancel')}}</el-button>
          <el-button @click='export_logList' type="primary" round>{{$t('terminal.confirm')}}</el-button>
          <!-- <div class="botton" @click='export_logList(tableHead)'><span>确定</span></div> -->
          <!-- <div class="botton" @click='close'><span>取消</span></div> -->
        </div>
      </div>
    </form-dialog>
  </div>
</template>

<script>
const year = new Date().getFullYear();
const month = new Date().getMonth();
const date = new Date().getDate();
const start = " 00:00:00";
const end = " 23:59:59"
import XLSX from 'xlsx';
import {
  dateFormat,
  timeFormatting
} from "@/assets/scripts/dateFormatting.js";
import FormDialog from "@/components/basics/FormDialog";
export default {
  name: 'ExportDialog',
  components: {
    FormDialog
  },
  props: {
    exportDialogVisible: {
      type: Boolean,
      default: false
    },
    logList: {
      type: Array,
    },
    type: {
      type: String
    },
    terminalStart: {

    },
    terminalEnd: {

    }
  },
  data() {
    return {
      dialogVisible: false,
      loginTableHead: ['设备名称', '设备SN', '组织结构', '类型', '操作时间'],
      operateTableHead: ['操作用户', '功能', '描述', '操作时间'],
      terminalTableHead: ['编号', '类型', '内容', '操作对象', '操作信息', '操作时间'],
      //startDate:this.type=="terminal" ? this.terminalStart._d == undefined ? this.terminalStart : new Date(Number(this.terminalStart._d)):new Date(year,month,date),
      startDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
      endDate: new Date(year, month, date),
      exportData: [],
      tStartDate: this.type == 'terminal' ? this.terminalStart._d == undefined ? this.terminalStart : new Date(
        Number(this.terminalStart._d)) : null,
      tEndDate: this.type == 'terminal' ? this.terminalEnd._d == undefined ? this.terminalEnd : new Date(Number(
        this.terminalEnd._d)) : null,
      default_tStartDate: this.type == 'terminal' ? this.terminalStart._d == undefined ? this.terminalStart :
        new Date(Number(this.terminalStart._d)) : null,
      default_tEndDate: this.type == 'terminal' ? this.terminalEnd._d == undefined ? this.terminalEnd : new Date(
        Number(this.terminalEnd._d)) : null,

    }
  },
  methods: {
    handleClose() {
      // 子组件调用父组件方法，并传递参数
      this.$emit('changeShow', 'false')
    },
    checkDate() {
      if (this.startDate > this.endDate) {
        this.check = false
      }
    },
    startDateChange() {
      this.checkDate();
      if (this.check == false) {
        //console.log(1)
      } else {
        //console.log(1)
      }
    },
    endDateChange() {
      this.checkDate();
    },
    sheet2blob(sheet, sheetName) {
      sheetName = sheetName || 'sheet1';
      let workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      };
      workbook.Sheets[sheetName] = sheet;
      // 生成excel的配置项
      let wopts = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      };
      let wbout = XLSX.write(workbook, wopts);
      let blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
      });
      // 字符串转ArrayBuffer
      function s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      }
      return blob;
    },
    openDownloadDialog(url, saveName) {
      if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      let aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      let event;
      if (window.MouseEvent) event = new MouseEvent('click');
      else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    },
    getExportData() {
      if (this.type == 'login') {
        this.$http.post('/admin/log/deviceLoginExport', {
          start_time: typeof (this.startDate) == 'object' ? dateFormat(this.startDate) + start : this
            .startDate + start,
          end_time: typeof (this.endDate) == 'object' ? dateFormat(this.endDate) + end : this
            .endDate + end
        }, data => {
          //console.log(data);

          let aoa = [
            this.loginTableHead,
          ];
          data.forEach(item => {
            aoa.push([item.device_name, item.device_sn, item.group_name, item.title, item
              .create_time
            ])
          })
          //console.log("aoa>>>>", aoa)
          let sheet = XLSX.utils.aoa_to_sheet(aoa);
          let Number = '';
          for (let i = 0; i < 6; i++) {
            Number += Math.floor(Math.random() * 10);
          }
          let file_name = "登录日志_" + dateFormat(new Date()) + "_" + Number + '.xlsx'
          //this.openDownloadDialog(this.sheet2blob(sheet), "登录日志.xlsx");
          this.openDownloadDialog(this.sheet2blob(sheet), file_name);
          this.dialogVisible = false;
        })
      } else if (this.type == "operate") {
        this.$http.post('/admin/log/userOperationExport', {
          start_time: typeof (this.startDate) == 'object' ? dateFormat(this.startDate) + start : this
            .startDate + start,
          end_time: typeof (this.endDate) == 'object' ? dateFormat(this.endDate) + end : this
            .endDate + end
        }, data => {
          //console.log(data);

          let aoa = [
            this.operateTableHead,
          ];
          data.forEach(item => {
            aoa.push([item.user_name, item.module + '/' + item.controller + '/' + item
              .action, item.title, item.create_time
            ])
          })
          //console.log("aoa>>>>", aoa)
          let sheet = XLSX.utils.aoa_to_sheet(aoa);
          let Number = '';
          for (let i = 0; i < 6; i++) {
            Number += Math.floor(Math.random() * 10);
          }
          let file_name = "操作日志_" + dateFormat(new Date()) + "_" + Number + '.xlsx'
          this.openDownloadDialog(this.sheet2blob(sheet), file_name);
          this.dialogVisible = false;
        })
      } else if (this.type == "terminal") {
        let export_start_date = typeof (this.tStartDate) == 'object' ? this.tStartDate.getTime() : this
          .tStartDate;
        let export_end_date = typeof (this.tEndDate) == 'object' ? this.tEndDate.getTime() : this.tEndDate;
        this.exportData = [];
        let aoa = [
          this.terminalTableHead,
        ];

        this.logList.forEach((ele) => {
          console.log(typeof (ele.TIME))
          if (typeof (ele.TIME) == 'string') {
            if (Date.parse(ele.TIME) >= export_start_date && Date.parse(ele.Time) <=
              export_end_date) {

              this.exportData.push(ele)
            }
          } else {

            if (ele.TIME >= export_start_date && ele.TIME <= export_end_date) {
              this.exportData.push(ele)
            }
          }

        })
        this.exportData.forEach((item) => {
          item.TIME = dateFormat(new Date(item.TIME)) + ' ' + timeFormatting(
            new Date(item.TIME));
          aoa.push([item._id, item.TYPE, item.CONTENT, item.OPERATOR, item.OPERATOR_INFO, item.TIME])
        })
        //console.log(this.exportData)
        let sheet = XLSX.utils.aoa_to_sheet(aoa);
        let Number = '';
        for (let i = 0; i < 6; i++) {
          Number += Math.floor(Math.random() * 10);
        }
        let file_name = "终端日志_" + dateFormat(new Date()) + "_" + Number + '.xlsx'
        this.openDownloadDialog(this.sheet2blob(sheet), file_name);
        this.dialogVisible = false;
        //console.log('time',Date.parse(this.logList[0].TIME));
      }
      this.$emit('changeShow', 'false');
    },
    export_logList() {
      //tableHead表头 格式：['姓名', '性别', '年龄', '注册时间']
      // console.log(this.logList);
      // console.log(this.export_date)
      // let aoa = [
      // 	this.tableHead,
      // ];
      // const starDate = typeof(this.export_date[0]) == "string" ? this.export_date[0] : this.export_date[0].toLocaleDateString();
      // const endDate = typeof(this.export_date[1]) == "string" ? this.export_date[1] : this.export_date[1].toLocaleDateString();
      // this.logList.forEach(item => {
      // 	if(item.create_time>=starDate&&item.create_time<=endDate){
      // 		aoa.push([item.device_name, item.device_sn, item.group_name, item.title, item.create_time])
      // 		console.log("筛选出来....",item.create_time)
      // 	}
      // })
      // let sheet = XLSX.utils.aoa_to_sheet(aoa);
      // this.openDownloadDialog(this.sheet2blob(sheet), '日志.xlsx');
      if (this.type == 'terminal') {

        let export_start_date = typeof (this.tStartDate) == 'object' ? this.tStartDate.getTime() : this
          .tStartDate;
        let export_end_date = typeof (this.tEndDate) == 'object' ? this.tEndDate.getTime() : this.tEndDate;

        if (export_start_date >= this.default_tStartDate.getTime() && export_end_date <= this
          .default_tEndDate.getTime()) {
          this.getExportData();
        } else {
          this.$msg({
            message: this.$t('log.exportTips'),
            type: 'warnig'
          })
        }

      } else {
        this.getExportData();
      }
    },
    close() {
      this.$emit('changeShow', 'false')
    }
  },
  created() {
    // if(this.type=='terminal'){
    // 	this.startDate = this.terminalStart._d == undefined ? this.terminalStart : new Date(Number(this.terminalStart._d));
    // 	this.endDate = this.terminalEnd._d == undefined ? this.terminalEnd : new Date(Number(this.terminalEnd._d));
    // 	console.log("start",this.startDate)
    // 	console.log('star..',this.startDate);
    // 	console.log('end..',this.endDate);
    // }
  },
  // mounted() {
  // 	const newDate = new Date();
  // 	//console.log(newDate.toDateString());
  // },
  watch: {
    // 监听 addOrUpdateVisible 改变
    exportDialogVisible() {
      this.dialogVisible = this.exportDialogVisible
    },
    terminalStart() {
      this.tStartDate = new Date(this.terminalStart);
    },
    terminalEnd() {
      this.tEndDate = new Date(this.terminalEnd)
    }
  }
}
</script>

<style lang="scss" scoped>
.exdialog {
  width: 700px;
  .content {
    //height: 20vh;
    // border: 1px solid red;
    .picker {
      display: flex;
      align-items: center;
      margin: 30px auto;
      padding-left: 20px;
      text-align: center;
    }

    .picker span {
      white-space: nowrap;
    }

    .button_group {
      width: 40%;
      margin: 40px auto;
      display: flex;
      justify-content: space-between;

      // .botton {
      // 	border: 1px solid skyblue;
      // 	width: 10vw;
      // 	height: 4vw;
      // 	border-style: solid;
      // 	border-radius: 40px;
      // 	position: relative;
      // 	text-align: center;
      // 	// border-image-source: linear-gradient(270deg,
      // 	// 		#86eae7 0%,
      // 	// 		#4cccf0 45%,
      // 	// 		#11adf8 100%);
      // 	// border-image-slice: 1;
      // }

      // .botton span {
      // 	// width: 3vw;
      // 	// height: 2vw;
      // 	font-family: PingFang-SC-Regular;
      // 	font-size: 1.5vw;
      // 	font-weight: normal;
      // 	font-stretch: normal;
      // 	line-height: 0vw;
      // 	letter-spacing: 0vw;
      // 	color: #2fb3ff;
      // 	position: absolute;
      // 	left: 50%;
      // 	top: 50%;
      // 	transform: translate(-50%,-50%);
      // }

      // .botton::before {
      // 	display: inline-block;
      // 	content: "";
      // 	height: 100%;
      // 	vertical-align: middle;
      // }
    }
  }
}

.pick {
  display: flex;
  align-items: center;
}

.pick /deep/ .el-date-editor {
  border-radius: 30px;
  background-color: pink;
  width: 180px;
}

.pick /deep/ .el-input__inner {
  //border-style: none;
  border-radius: 30px;
  width: 180px;
  //background-color: #edfbff;
}

/deep/ .el-dialog__title {
  color: #ffffff;
  font-size: 20px;
  line-height: 24px;
}

/deep/ .el-dialog {
  border-radius: 1vw 1vw 0vw 0vw;
}

/deep/ .el-dialog__header {
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#ffffff, #ffffff);
  background-blend-mode: normal, normal;
  border-radius: 1vw 1vw 0vw 0vw;
}

// /deep/ .el-button {
// 	border-color: red;
// }
</style>
